export type AppEnvironment = "test" | "prod";

/**
 * Sentry environment per serving host`.
 *
 * The same build is deployed to both Development and Production, so the
 * environment is resolved from the request host at runtime instead of at
 * build time.
 */
const HOST_ENVIRONMENTS: Record<string, AppEnvironment> = {
  "onboarding.roaring.io": "prod",
  "onboarding.test.rawrr.org": "test",
};

/**
 * Returns `undefined` for hosts we don't know (localhost, previews, ...).
 * Events from unknown hosts are dropped so they are never mislabeled.
 */
export function resolveAppEnvironment(
  hostname: string | undefined
): AppEnvironment | undefined {
  if (!hostname) return undefined;
  const host = hostname.split(":")[0].toLowerCase();
  return Object.hasOwn(HOST_ENVIRONMENTS, host)
    ? HOST_ENVIRONMENTS[host]
    : undefined;
}

/** Whether events from this host should be traced at all. */
export function isTraceableHost(hostname: string | undefined): boolean {
  return resolveAppEnvironment(hostname) !== undefined;
}
